<template>
  <form>
    <div class="two-column-form-container prochip-form-container margin-top-20">
      <div class="wd-50">
        <div class="text-control">
          <input
            type="text"
            id="hostID"
            class="text-input flex-fill"
            v-model.trim="v$.hostID.$model"
            :class="{
              'error-text-control':
                v$.hostID.$errors && v$.hostID.$errors.length > 0,
            }"
            @input="formValueChanged(v$.hostID)"
            @blur="v$.hostID.$touch"
            aria-describedby="hostID-error"
            aria-required="true"
            :aria-invalid="v$.hostID.$errors.length > 0"
            title="Please fill in the Host ID or Flex ID.HostID format should be XX-XX-XX-XX-XX-XX. FlexID format should be X-XXXXXXXX or XX-XXXXXXXX."
          />
          <label
            for="hostID"
            class="text-label"
            :class="{
              'error-label': v$.hostID.$errors && v$.hostID.$errors.length > 0,
            }"
            >HostID or FlexID</label
          >
          <span class="required">*</span>
          <a href="https://www.microchip.com/en-us/support/guide-to-find-host-id" target="_blank" class="prochip-info-link">
            <i class="fa fa-info-circle info-icon" title="To obtain the HostID, type ipconfig/all at the DOS command prompt. The HostID is the 12-digit hexadecimal number (e.g. 00-00-1A-4E-F8-0A) shown as the Physical Address of the Ethernet or wireless LAN adapter. The FlexID is on the label of the security key."></i>
          </a>
        </div>
        <div class="input-errors" id="hostID-error" aria-live="assertive" aria-relevant="all">
          <div
            class="error-msg"
            v-for="(error, index) of v$.hostID.$errors"
            :key="index"
          >
            {{ error.$message }}
          </div>
        </div>
      </div>
      <div class="wd-45">
        <div v-if="headerName === 'Request a 2-year license'" class="text-control">
          <input
            type="text"
            id="orderID"
            class="text-input flex-fill"
            v-model.trim="v$.orderID.$model"
            :class="{
              'error-text-control':
                v$.orderID.$errors && v$.orderID.$errors.length > 0,
            }"
            @input="formValueChanged(v$.orderID)"
            @blur="v$.orderID.$touch"
            aria-describedby="orderID-error"
            aria-required="true"
            :aria-invalid="v$.orderID.$errors.length > 0"
            title="Please fill in the Host ID or Flex ID.orderID format should be XX-XX-XX-XX-XX-XX. FlexID format should be X-XXXXXXXX or XX-XXXXXXXX."
          />
          <label
            for="orderID"
            class="text-label"
            :class="{
              'error-label': v$.orderID.$errors && v$.orderID.$errors.length > 0,
            }"
            >Sales Order/Invoice #</label
          >
          <span class="required">*</span>
        </div>
        <div v-if="headerName === 'Request a 2-year license'" class="input-errors" id="orderID-error" aria-live="assertive" aria-relevant="all">
          <div
            class="error-msg"
            v-for="(error, index) of v$.orderID.$errors"
            :key="index"
          >
            {{ error.$message }}
          </div>
        </div>
      </div>
    </div>
    <div class="two-column-form-container">
      <div class="wd-50">
        <div class="select-control">
          <select
            id="productionYear"
            v-model.trim="v$.productionYear.$model"
            :class="{
              'error-select':
                v$.productionYear.$errors &&
                v$.productionYear.$errors.length > 0,
            }"
            @change="formValueChanged(v$.productionYear)"
            @blur="v$.productionYear.$touch"
            aria-describedby="productionYear-error"
            aria-required="true"
            :aria-invalid="v$.productionYear.$errors.length > 0"
          >
            <option v-for="py in productionYears" :key="py" :value="py">
              {{ py }}
            </option>
          </select>
          <label
            class="select-label"
            :class="{
              'error-select-label':
                v$.productionYear.$errors &&
                v$.productionYear.$errors.length > 0,
            }"
            for="productionYear"
            >When is your design planned for production?</label
          >
          <span class="required">*</span>
        </div>
        <div class="input-errors"  id="productionYear-error" aria-live="assertive" aria-relevant="all">
          <div
            class="error-msg"
            v-for="(error, index) of v$.productionYear.$errors"
            :key="index"
          >
            {{ error.$message }}
          </div>
        </div>
      </div>
      <div class="wd-45">
        <div class="select-control">
          <select
            id="cpld"
            v-model.trim="v$.cpld.$model"
            :class="{
              'error-select': v$.cpld.$errors && v$.cpld.$errors.length > 0,
            }"
            @change="formValueChanged(v$.cpld)"
            @blur="v$.cpld.$touch"
            aria-describedby="cpld-error"
            aria-required="true"
            :aria-invalid="v$.cpld.$errors.length > 0"
          >
            <option v-for="c in cplds" :key="c" :value="c">
              {{ c }}
            </option>
          </select>
          <label
            class="select-label"
            :class="{
              'error-select-label':
                v$.cpld.$errors && v$.cpld.$errors.length > 0,
            }"
            for="cpld"
            >Which CPLD will you be using?</label
          >
          <span class="required">*</span>
        </div>
        <div class="input-errors" id="cpld-error" aria-live="assertive" aria-relevant="all">
          <div
            class="error-msg"
            v-for="(error, index) of v$.cpld.$errors"
            :key="index"
          >
            {{ error.$message }}
          </div>
        </div>
      </div>
    </div>
    <div class="two-column-form-container">
      <div class="wd-50">
        <div class="select-control">
          <select
            id="cpldVolume"
            v-model.trim="v$.cpldVolume.$model"
            :class="{
              'error-select':
                v$.cpldVolume.$errors && v$.cpldVolume.$errors.length > 0,
            }"
            @change="formValueChanged(v$.cpldVolume)"
            @blur="v$.cpldVolume.$touch"
            aria-describedby="cpldVolume-error"
            aria-required="true"
            :aria-invalid="v$.cpldVolume.$errors.length > 0"
          >
            <option v-for="cv in cpldVolumes" :key="cv" :value="cv">
              {{ cv }}
            </option>
          </select>
          <label
            for="cpldVolume"
            class="select-label desktop"
            :class="{
              'error-select-label':
                v$.cpldVolume.$errors && v$.cpldVolume.$errors.length > 0,
            }"
            >What are the potential quantities per year(or total CPLD volume)
            you plan to use in your design(s)?</label
          >
          <label
            for="cpldVolume"
            class="select-label mobile"
            :class="{
              'error-select-label':
                v$.cpldVolume.$errors && v$.cpldVolume.$errors.length > 0,
            }"
            >Total CPLD volume?</label
          >
          <span class="required">*</span>
        </div>
        <div class="input-errors" id="cpldVolume-error" aria-live="assertive" aria-relevant="all">
          <div
            class="error-msg"
            v-for="(error, index) of v$.cpldVolume.$errors"
            :key="index"
          >
            {{ error.$message }}
          </div>
        </div>
      </div>
      <div class="wd-45">
        <div class="select-control">
          <select
            id="hdlPreference"
            v-model.trim="v$.hdlPreference.$model"
            :class="{
              'error-select':
                v$.hdlPreference.$errors && v$.hdlPreference.$errors.length > 0,
            }"
            @change="formValueChanged(v$.hdlPreference)"
            @blur="v$.hdlPreference.$touch"
            aria-describedby="hdlPreference-error"
            aria-required="true"
            :aria-invalid="v$.hdlPreference.$errors.length > 0"
          >
            <option v-for="hp in hdlPreferences" :key="hp" :value="hp">
              {{ hp }}
            </option>
          </select>
          <label
            class="select-label desktop"
            :class="{
              'error-select-label':
                v$.hdlPreference.$errors && v$.hdlPreference.$errors.length > 0,
            }"
            for="hdlPreference"
            >What is your HDL preference?</label
          >
          <label
            class="select-label mobile"
            :class="{
              'error-select-label':
                v$.hdlPreference.$errors && v$.hdlPreference.$errors.length > 0,
            }"
            for="hdlPreference"
            >HDL preference?</label
          >
          <span class="required">*</span>
        </div>
        <div class="input-errors" id="hdlPreference-error" aria-live="assertive" aria-relevant="all">
          <div
            class="error-msg"
            v-for="(error, index) of v$.hdlPreference.$errors"
            :key="index"
          >
            {{ error.$message }}
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { reactive, computed, watch } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { useRoute } from 'vue-router';
import { required, maxLength, helpers } from "@vuelidate/validators";

export function validHostOrFlexID(hostID) {
  let validHostIDPattern = new RegExp(
    "^[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}$"
  );
  let validFlexIDPattern = new RegExp("^([A-Fa-f0-9]{1,2}-[A-Fa-f0-9]{8})$");
  if (validHostIDPattern.test(hostID) || validFlexIDPattern.test(hostID)) {
    return true;
  }
  return false;
}

export function isFilled(word) {
  if (word){
    return true;
  }
  return false;
}

export default {
  props: ["productionYears", "cplds", "cpldVolumes", "hdlPreferences"],
  emits: ["prochipDataChanged"],
  components: {
  },
  setup(props, context) {
    const form = reactive({
      hostID: "",
      productionYear: null,
      cpld: null,
      cpldVolume: null,
      hdlPreference: null,
      orderID: ""
    });
    const route = useRoute();
    const headerName = computed(() => route.meta.headerName);

    const rules = computed(() => {
    const baseRules = {
      hostID: {
        required: {
          $validator: isFilled,
          $message: 'Please fill in the Host ID or Flex ID.'
        },
        hostID_validation: {
          $validator: validHostOrFlexID,
          $message: "HostID format should be XX-XX-XX-XX-XX-XX. FlexID format should be X-XXXXXXXX or XX-XXXXXXXX.",
        },
      },
      productionYear: {
        required: {
          $validator: isFilled,
          $message: 'Please select a Production Year.'
        },
      },
      cpld: {
        required: {
          $validator: isFilled,
          $message: 'Please select CPLD.'
        },
      },
      cpldVolume: {
        required: {
          $validator: isFilled,
          $message: 'Please select a CPLD Volume.'
        },
      },
      hdlPreference: {
        required: {
          $validator: isFilled,
          $message: 'Please select a HDL Preference.'
        },
      },
    };

    if (headerName.value === 'Request a 2-year license') {
      baseRules.orderID = {
        required: {
          $validator: isFilled,
          $message: 'Please fill in the Sales Order/Invoice #.',
        },
        maxLength: helpers.withMessage(
            "The maximum length allowed is 30.",
            maxLength(30)
        ),
      };
    }

    return baseRules;
  });

    const v$ = useVuelidate(rules, form);
    watch(headerName, () => {
      v$.value.$validate();
    });
    function formValueChanged(ref) {
      ref.$touch;
      context.emit("prochipDataChanged", {
        hostID: form.hostID,
        orderID: form.orderID,
        productionYear: form.productionYear,
        cpld: form.cpld,
        cpldVolume: form.cpldVolume,
        hdlPreference: form.hdlPreference,
        isFormInvalid:
          v$._value.$errors.length > 0 || v$._value.$silentErrors.length > 0,
      });
    }
    
    // const microchipUrl = process.env.VUE_APP_VF_URL;
    return {
      form,
      v$: v$,
      formValueChanged,
      headerName,
      // microchipUrl
    };
  },
};
</script>
<style lang="scss" scoped>
.prochip-info-link {
  order: 4;
  margin-left: 3px;
  i {
   color: #1c355e;
  }
  :hover {
    color: #157eac;
  }
}
</style>